import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-116">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-117">
        <a href="#inicio" className="flex items-center group transition-transform group-hover:scale-105" data-id="element-118">
          <img src="https://cdn.magicpatterns.com/uploads/rZWYtw45vF5kRX1tewyoD9/WhatsApp_Image_2026-04-14_at_10.49.05-removebg-preview.png" alt="JML Ingeniería y Mantenimiento Industrial" className="h-16 w-auto object-contain brightness-0 invert" data-id="element-119" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-120">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-jml-orange transition-colors tracking-wide" data-id="element-121">
              {link.name}
            </a>)}
          <a href="https://wa.me/56921239377?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-jml-blue hover:bg-blue-700 text-white text-sm font-semibold rounded-md transition-colors shadow-lg shadow-jml-blue/20" data-id="element-122">
            Cotizar Servicio
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-123">
          {isMobileMenuOpen ? <X size={24} data-id="element-124" /> : <Menu size={24} data-id="element-125" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-126">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-light border-t border-white/10 overflow-hidden" data-id="element-127">
            <div className="flex flex-col px-6 py-4 gap-4" data-id="element-128">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-gray-300 hover:text-jml-orange transition-colors" data-id="element-129">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}